import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import type { NClientFiles } from '@app/types/ClientFiles';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

export type GetFileImageProps = {
  fileName: string | null;
  filesWithData: NClientFiles.ModelClientFileForCreation[] | null;
  Thumbnail?: string | null;
  isHistoryItem?: boolean;
  fileExtension?: string | null;
};

export const getFileImage = ({
  fileName,
  filesWithData,
  Thumbnail,
  isHistoryItem,
  fileExtension,
}: GetFileImageProps) => {
  if (fileName && filesWithData) {
    const extension = fileExtension
      ? fileExtension.toLowerCase()
      : fileName.split('.').pop();
    switch (extension) {
      case 'jpg':
      case 'png':
      case 'jpeg':
        return (
          <img
            className={'file-avatar'}
            src={`data:image/png;base64,${
              Thumbnail
                ? Thumbnail
                : filesWithData.find((file) => file.FileName === fileName)?.Data
            }`}
            alt="Логотип"
          />
        );
      case 'pdf':
        return (
          <FontAwesomeIcon
            icon={'fa-regular fa-file-pdf' as IconProp}
            size={'lg'}
            style={{
              width: `${isHistoryItem ? '20px' : '35px'}`,
              height: `${isHistoryItem ? '20px' : '35px'}`,
              marginRight: `${isHistoryItem ? '-2px' : '5px'}`,
              marginLeft: `${isHistoryItem ? '-1px' : '0px'}`,
            }}
          />
        );
      case 'xls':
      case 'xlsx':
        return (
          <FontAwesomeIcon
            icon={'fa-regular fa-file-excel' as IconProp}
            size={'lg'}
            style={{
              width: `${isHistoryItem ? '20px' : '35px'}`,
              height: `${isHistoryItem ? '20px' : '35px'}`,
              marginRight: `${isHistoryItem ? '0' : '5px'}`,
              marginLeft: `${isHistoryItem ? '-3px' : '-5px'}`,
            }}
          />
        );
      case 'doc':
      case 'docx':
        return (
          <FontAwesomeIcon
            icon={'fa-regular fa-file-word' as IconProp}
            size={'lg'}
            style={{
              width: `${isHistoryItem ? '20px' : '35px'}`,
              height: `${isHistoryItem ? '20px' : '35px'}`,
              marginRight: `${isHistoryItem ? '0' : '5px'}`,
            }}
          />
        );
      default:
        return (
          <FontAwesomeIcon
            icon={'fa-regular fa-file' as IconProp}
            size={'lg'}
            style={{
              width: `${isHistoryItem ? '20px' : '35px'}`,
              height: `${isHistoryItem ? '20px' : '35px'}`,
              marginRight: `${isHistoryItem ? '0' : '5px'}`,
              marginLeft: `${isHistoryItem ? '-3px' : '-5px'}`,
            }}
          />
        );
    }
  }
};
